import { Component, Input, OnInit } from '@angular/core';
import { TourModel } from 'src/app/guru-api/models/tour.model';

@Component({
  selector: 'app-tram-tour-display',
  templateUrl: './tram-tour-display.component.html',
  styleUrls: ['./tram-tour-display.component.scss']
})
export class TramTourDisplayComponent implements OnInit {

  @Input() tramtour: TourModel;
  constructor() { }

  ngOnInit(): void {
  }

}
